$(document).ready(function () {
  $(".collection-item").hover(function () {
        $(this).closest(".collection-slider").find(".collection-item").addClass("sibling"), $(this).removeClass("sibling");
    },function () {
        $(".collection-item").removeClass("sibling");
    }
  );
  $('.header-menu details').hover(function () {
      $('#MainContent').addClass('blurred');
      $(this).attr('open', '').addClass('opened');
    }, function () {
      $('#MainContent').removeClass('blurred');
      $(this).removeAttr('open').removeClass('opened');
    }
  );
});

$(document).ready(function () {
  $('.collection-slider').owlCarousel({
    autoplayHoverPause: true,
    loop: true,
    autoplay: true,
    autoplaySpeed: 6000,
    autoplayTimeout: 2000,
    autoplayHoverPause: true,
    smartSpeed: 500,
    slideTransition: 'linear',
    dots: false,
    nav: false,
    rtl: true,
    responsive:{
      0:{
          items:4
      },
      750:{
          items:5
      },            
      1024:{
          items:6
      }
    }
  });
});

jQuery(document).ready(function ($) {
  $('.testimo-slider').owlCarousel({
    loop: true,
    // autoplay: true,
    // autoplaySpeed: 5000,
    autoplayHoverPause: true,
    nav: true,
    navText: [
      '<svg class="custom-navigation-button-icon" width="14" height="12" viewBox="0 0 14 12" fill="none"> <path class="bar" d="M12 6H1" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path> <path class="handle" d="M5.5 1.5L1 6L5.5 10.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path> </svg>',
      '<svg class="custom-navigation-button-icon" width="14" height="12" viewBox="0 0 14 12" fill="none"> <path class="bar" d="M1.5 6H12.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path> <path class="handle" d="M8 1.5L12.5 6L8 10.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path> </svg>'],
    dots: false,
    // margin: 30,
    responsive:{
      0:{
          center: false,
          items:1
      },
      600:{
          center: false,
          items:2
      },            
      960:{
          center: true,
          items:3
      }
    }
  });
});

document.querySelectorAll('.card-wrapper .form').forEach(function(form) {
  const quantityInput = form.querySelector('.quantity-input');
  const plusBtn = form.querySelector('.plus-btn');
  const minusBtn = form.querySelector('.minus-btn');

  // Event listener for the plus button
  plusBtn.addEventListener('click', function() {
    let currentValue = parseInt(quantityInput.value) || 1; // Ensure the value is a number
    quantityInput.value = currentValue + 1;
  });

  // Event listener for the minus button
  minusBtn.addEventListener('click', function() {
    let currentValue = parseInt(quantityInput.value) || 1; // Ensure the value is a number
    if (currentValue > 1) {
      quantityInput.value = currentValue - 1;
    }
  });
});